import { useReduxState } from 'hooks';
import { ApiDownloadButton, FlexContainer } from 'components/common';
import { getColumnOptionsByProductType } from 'shared-helpers/analytics';

interface Props {
  userIds: number[];
}

const PathParticipantsExportExcel = ({ userIds }: Props) => {
  const {
    language,
    messages,
    pageState: { path },
    serverConfig,
    user
  } = useReduxState();

  const columns = (
    getColumnOptionsByProductType({
      language,
      messages,
      requestUser: user,
      serverConfig,
      type: 'paths'
    }) || []
  )
    // exclude categories
    .filter(({ value }) => value !== 'product.categories')
    .reduce((columns, { value }) => {
      value
        .split('.')
        .reduce(
          (acc, key, index, arr) =>
            (acc[key] = index === arr.length - 1 ? true : acc[key] || {}),
          columns
        );
      return columns;
    }, {});

  return (
    <div>
      <FlexContainer style={{ gap: 10 }}>
        <ApiDownloadButton
          category="success"
          filename={`${serverConfig.hostname}_${path.title}.xlsx`}
          icon="file-excel"
          packet={{
            includeAllUsers: true,
            language,
            productIds: [path.id],
            type: 'paths',
            userIds: userIds,
            columns
          }}
          size="header"
          text={messages.commonExportToExcel}
          url={'/admin/analytics/excel-exports'}
        />
      </FlexContainer>
    </div>
  );
};

export default PathParticipantsExportExcel;
